module.exports = {
  "accordion-wrapper": {
    "paddingLeft": "32",
    "paddingRight": "32"
  },
  "accordion-item": {
    "alignItems": "center",
    "justifyContent": "space-between",
    "flexDirection": "row",
    "height": "92",
    "borderBottomColor": "#e5e5e8",
    "borderBottomWidth": "1"
  },
  "accordion-title": {
    "flex": 1,
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "32",
    "color": "#1E2E37"
  },
  "accordion-icon": {
    "height": "40",
    "width": "40",
    "marginRight": "24"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-756307a5!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-accordion/index.vue
// module id = 510
// module chunks = 0 1